import React, { useContext } from "react";
import PropTypes from "prop-types";

import Spinner from "@atlaskit/spinner";

import { getIconSVG } from "../../../Service/icons";
import { PROVIDERS } from "../../MacroIcon/Icon";
import { SidebarIconsContext } from "./Context";
import {
  IconsContainer,
  MessageContainer,
  SingleIconContainer,
} from "./styled/Components";
import { useTheme } from "styled-components";

function Icons({ selected }) {
  const { selectedProvider, searchTerm, onIconSelect, isLoading } =
    useContext(SidebarIconsContext);

  const theme = useTheme();

  if (isLoading) {
    return (
      <MessageContainer style={{ paddingTop: "20px" }}>
        <Spinner size="large" />
      </MessageContainer>
    );
  }

  const providerIcons = PROVIDERS.map(({ key, name }) => {
    let icons = [];

    if (selectedProvider === key) {
      const set = window.iconSets.find(({ provider }) => provider === key);

      if (set?.icons) {
        icons = set.icons.filter(([iconName]) =>
          iconName.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
    }

    return { name, key, icons };
  }).filter(({ icons }) => icons.length);

  return providerIcons.length ? (
    providerIcons.map(({ icons, key }) => (
      <IconsContainer key={key}>
        {icons.map((icon) => (
          <SingleIconContainer
            color={theme.shared.sidebar.icon.color}
            isSelected={selected === `${key}/${icon[0]}`}
            title={icon[0]}
            key={icon[0]}
            onClick={() => onIconSelect(`${key}/${icon[0]}`)}
            dangerouslySetInnerHTML={{
              __html: getIconSVG(icon, key),
            }}
          />
        ))}
      </IconsContainer>
    ))
  ) : (
    <MessageContainer border={theme.shared.sidebar.divider}>
      No icons found for:&nbsp;&quot;
      <span>{searchTerm}</span>
      &quot;
    </MessageContainer>
  );
}

Icons.defaultProps = {
  icon: null,
};

Icons.propTypes = {
  icon: PropTypes.string,
};

export default Icons;
